module.exports = __webpack_public_path__ + "static/media/chess_telegram.9dd78e60.mp4";